import { render, staticRenderFns } from "./EditTagPage.vue?vue&type=template&id=8570a260&"
import script from "./EditTagPage.vue?vue&type=script&lang=js&"
export * from "./EditTagPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports